var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("report.newDialog.title")))]),
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.formValid,
            callback: function($$v) {
              _vm.formValid = $$v
            },
            expression: "formValid"
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.reportTypeNames,
                      label: _vm.$t("report.reportType"),
                      rules: [_vm.requiredValidator]
                    },
                    model: {
                      value: _vm.reportForm.report_type,
                      callback: function($$v) {
                        _vm.$set(_vm.reportForm, "report_type", $$v)
                      },
                      expression: "reportForm.report_type"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "px-2", attrs: { cols: "2" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.file_formats,
                      label: _vm.$t("report.fileFormat"),
                      rules: [_vm.requiredValidator]
                    },
                    model: {
                      value: _vm.reportForm.file_format,
                      callback: function($$v) {
                        _vm.$set(_vm.reportForm, "file_format", $$v)
                      },
                      expression: "reportForm.file_format"
                    }
                  })
                ],
                1
              ),
              _vm.reportForm.report_type !== null &&
              _vm.reportTypeNames.find(function(v) {
                return v.value === _vm.reportForm.report_type
              }).exchange
                ? [
                    _c(
                      "v-col",
                      { staticClass: "px-2", attrs: { cols: "2" } },
                      [
                        _c("currency-select", {
                          attrs: {
                            model: _vm.reportForm.currency,
                            rules: [_vm.requiredValidator]
                          },
                          on: {
                            "update:model": function($event) {
                              return _vm.$set(
                                _vm.reportForm,
                                "currency",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { staticClass: "px-2", attrs: { cols: "2" } },
                      [
                        _c("date-picker", {
                          attrs: {
                            model: _vm.reportForm.exchange_rate_date,
                            label: _vm.$t("report.exchangeRateDate"),
                            rules: [_vm.requiredValidator]
                          },
                          on: {
                            "update:model": function($event) {
                              return _vm.$set(
                                _vm.reportForm,
                                "exchange_rate_date",
                                $event
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _c(
                "v-col",
                { staticClass: "px-2", attrs: { cols: "2" } },
                [
                  _c("v-select", {
                    attrs: {
                      label: _vm.$t("global.numberFormat"),
                      items: _vm.numberFormats
                    },
                    model: {
                      value: _vm.reportForm.number_format_type,
                      callback: function($$v) {
                        _vm.$set(_vm.reportForm, "number_format_type", $$v)
                      },
                      expression: "reportForm.number_format_type"
                    }
                  })
                ],
                1
              )
            ],
            2
          ),
          _c("select-delegation-by-criteria-component", {
            attrs: {
              filters: _vm.reportForm.criteria,
              delegation_ids: _vm.reportForm.delegation_ids,
              "get-delegations-address": "/report/get-delegations",
              "get-filter-data-address": "/report/get-filters-data"
            },
            on: {
              "update:filters": function($event) {
                return _vm.$set(_vm.reportForm, "criteria", $event)
              },
              "update:delegation_ids": function($event) {
                return _vm.$set(_vm.reportForm, "delegation_ids", $event)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "action",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.downloadDelegation(
                                              item.id
                                            )
                                          }
                                        }
                                      },
                                      on
                                    ),
                                    [
                                      _c("v-icon", [
                                        _vm._v("mdi-file-download")
                                      ])
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("global.downloadFile")) + " "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c(
            "v-row",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { staticClass: "accent", on: { click: _vm.generate } },
                [
                  _vm._v(
                    _vm._s(_vm.$t("report.newDialog.generateReportButton"))
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }